{
  "title": "Essay review",
  "subtitle": "Upload an essay or paste text — get a 6-criteria score and inline annotations.",
  "list": {
    "title": "All essays",
    "subtitle": "Upload an essay or paste text — get a 6-criteria score and inline annotations.",
    "empty": {
      "title": "No essays yet",
      "subtitle": "Upload text or PDF — you'll get a score in 1–2 minutes.",
      "cta": "Upload essay"
    },
    "search": "Search by title…",
    "count": "{count, plural, one {# essay} other {# essays}}",
    "wordCount": "{count, plural, one {# word} other {# words}}",
    "errorTitle": "Couldn't load essays",
    "errorSubtitle": "Check your connection or try again later.",
    "retry": "Retry",
    "filtered": "Nothing matches the filters",
    "filteredReset": "Reset filters"
  },
  "filter": {
    "status": "Status",
    "all": "All"
  },
  "status": {
    "draft": "Draft",
    "queued": "Queued",
    "grading": "Grading",
    "ready": "Ready",
    "failed": "Failed"
  },
  "score": {
    "pending": "—",
    "label": "Score",
    "excellent": "Excellent work",
    "good": "Good result",
    "improving": "Room for improvement",
    "needsWork": "Needs significant work"
  },
  "actions": {
    "open": "Open",
    "downloadPdf": "Download PDF",
    "delete": "Delete"
  },
  "new": {
    "cta": "New essay",
    "title": "New essay",
    "subtitleV3": "Write, paste, or upload a file. The title is chosen automatically.",
    "tooShort": "Essay text is too short. Minimum 50 words.",
    "untitled": "Essay",
    "tab": {
      "write": "Write",
      "upload": "Upload PDF",
      "paste": "Paste",
      "text": "Text",
      "file": "File"
    },
    "essayTitleLabel": "Title",
    "essayTitlePlaceholder": "Argumentative essay on media",
    "bodyLabel": "Essay body",
    "bodyPlaceholder": "Start typing or paste text…",
    "bodyPlaceholderV2": "Type or paste your essay here…",
    "uploadHint": "Drop a PDF or DOCX",
    "uploadCta": "Choose file",
    "uploadComingSoon": "File upload — coming soon",
    "uploadComingSoonHint": "For now, paste the essay text in the «Paste» tab",
    "file": {
      "dropHint": "Drop a file or click to pick",
      "pickHint": "Tap to pick a file",
      "formats": "PDF, DOCX, TXT, MD — up to 10 MB",
      "extracting": "Extracting text…",
      "extracted": "Text extracted ({words} {words, plural, one {word} other {words}})",
      "extractError": "Could not extract text from the file",
      "networkError": "Upload failed",
      "tooLarge": "File is larger than 10 MB",
      "clear": "Clear"
    },
    "submit": "Submit for review",
    "cancel": "Cancel",
    "wordCount": "{count, plural, one {# word} other {# words}}"
  },
  "rename": {
    "label": "Essay title",
    "hint": "Rename",
    "error": "Couldn't rename"
  },
  "detail": {
    "back": "Back",
    "score": "Total",
    "gradedAt": "Graded",
    "downloadPdf": "Download PDF",
    "dispute": "Dispute score",
    "disputeStatus": "Dispute submitted",
    "disputeAlreadyOpen": "A dispute is already under review",
    "retry": "Try again",
    "loading": "Loading essay…",
    "noTitle": "Untitled",
    "maxScore": "Max: {score}",
    "scoreUnit": "{score} pts",
    "gradingMissingTitle": "Grade unavailable",
    "gradingMissingSubtitle": "The AI grade wasn't produced. Re-grade to get a score and annotations.",
    "regrade": "Regrade",
    "regenerate": "Re-annotate",
    "manualReview": "Manual review required",
    "manualReviewSubtitle": "This essay is queued for moderation. The final score may change.",
    "aiDetection": "AI-detection: {percent}%",
    "tab": {
      "essay": "Essay",
      "criteria": "Criteria",
      "summary": "Summary"
    },
    "summary": "Summary",
    "strengths": "Strengths",
    "improvements": "Areas to improve",
    "criteria": {
      "title": "Criteria",
      "level": "Level",
      "feedback": "Feedback",
      "details": "Details"
    },
    "annotations": {
      "title": "Annotations",
      "kind": {
        "praise": "Strong",
        "issue": "Issue",
        "suggestion": "Suggestion",
        "question": "Question",
        "reference": "Reference"
      },
      "criterion": "Criterion",
      "suggestedRewrite": "Suggested rewrite",
      "empty": "AI didn't add annotations"
    },
    "processing": {
      "title": "Essay is being graded",
      "subtitle": "This takes 1–2 minutes. You can close the page — we'll notify you.",
      "steps": {
        "extract": "Extracting text",
        "analyze": "Analyzing structure",
        "annotate": "Creating annotations",
        "score": "Scoring"
      }
    },
    "errorTitle": "Couldn't load essay",
    "failedTitle": "Grading failed",
    "failedSubtitle": "Try submitting the essay again.",
    "scoreOf": "Score"
  },
  "report": {
    "title": "Report",
    "download": "Download PDF",
    "open": "Open in new tab",
    "loading": "Preparing report…",
    "share": "Share with teacher",
    "mobileHint": "Open the report in a browser to view it.",
    "preparing": "Preparing…",
    "pending": "PDF in progress…"
  },
  "dispute": {
    "title": "Disagree with the grade?",
    "subtitle": "Tell us which criterion or overall score you disagree with. A moderator will review.",
    "criterionLabel": "Criterion",
    "criterionPlaceholder": "Pick a criterion",
    "overall": "Overall score",
    "reasonLabel": "Why you disagree",
    "reasonPlaceholder": "E.g. \"The AI missed that I used a concrete historical example in paragraph 2…\"",
    "minChars": "Minimum 10 characters",
    "suggestedScoreLabel": "Fair score (optional)",
    "submit": "Send",
    "cancel": "Cancel",
    "sent": "Submitted",
    "sentHint": "A moderator will review within 2 business days",
    "alreadyOpen": "A dispute is already submitted",
    "error": "Couldn't submit",
    "flowHint": "A moderator will compare the grade with your argument and the grading criteria. You will get a notification within 2 business days."
  },
  "regrade": {
    "title": "Start re-grading?",
    "description": "AI will re-score the essay and rebuild inline annotations. Current annotations will be replaced. This counts toward your quota.",
    "confirm": "Re-grade"
  },
  "toast": {
    "ready": "Essay graded",
    "readyHint": "Final score: {score} / 100",
    "reportReady": "PDF report is ready",
    "reportReadyHint": "Download PDF is now available",
    "pdfNotReady": "PDF not ready yet",
    "pdfError": "Couldn't fetch PDF",
    "regradeStarted": "Re-grading started",
    "regradeStartedHint": "Allow 30–60 seconds",
    "regradeError": "Couldn't start",
    "created": "Essay submitted for review",
    "createError": "Couldn't create essay",
    "deleted": "Essay deleted",
    "deleteError": "Couldn't delete"
  },
  "criteria": {
    "thesis": "Thesis",
    "structure": "Structure",
    "arguments": "Argumentation",
    "evidence": "Evidence",
    "style": "Style & language",
    "grammar": "Grammar & punctuation",
    "originality": "Originality"
  },
  "delete": {
    "title": "Delete essay?",
    "subtitle": "The essay and report will move to trash for 30 days.",
    "confirm": "Delete",
    "cancel": "Cancel"
  },
  "errors": {
    "ESSAY_TOO_SHORT": "The essay is too short. Minimum length is 50 words.",
    "ESSAY_NOT_FOUND": "Essay not found.",
    "ESSAY_ALREADY_IN_PROGRESS": "This essay is already being graded.",
    "ESSAY_IS_GRADING": "The essay is currently being graded, please wait.",
    "ESSAY_NOT_GRADED": "The essay has not been graded yet.",
    "ESSAY_NOT_GRADED_YET": "The essay has not been graded yet.",
    "aggregate_parse_failed": "An error occurred while analyzing the grade structure. We are already working on a fix, please try regrading the essay later.",
    "aggregate_no_criteria": "The AI failed to identify grading criteria. Please try regrading.",
    "aggregate_no_feedback": "The AI returned empty feedback. Please try regrading."
  },
  "intro": {
    "title": "Here the AI grades, it does not write",
    "body": "The only section where your own text is assessed instead of new material being produced. You can add your own remarks and ask for a re-check.",
    "bullets": [
      "Takes pdf, docx, txt and markdown, or pasted text",
      "Your own remarks sit on top of the AI's",
      "The result exports to PDF with a fix checklist"
    ]
  }
}
